import React, { useRef, useState } from 'react';
import EditCard, { type EditCardRef, type EditCardConfig } from '../components/EditCard/EditCard';
import { authStorage } from '../lib/storage';

const EditCardTestPage: React.FC = () =>
{
  const editCardRef = useRef<EditCardRef>(null);
  const [lastSavedData, setLastSavedData] = useState<any>(null);

  const config: EditCardConfig = {
    apiUrl: import.meta.env.VITE_API_URL || '',
    authToken: authStorage.getAccessToken() || '',
    functions: {
      loadingBarStart: () => {},
      loadingBarComplete: () => {},
      conversationResponse: (_request: any, response: any) =>
      {
        setLastSavedData(response);
      },
    },
    params: {
      Conversation: {
        ProjectId: 8089, // Using a dummy active project ID
        ConfigValueId: 9, // Assuming Project
        Title: 'Test Card Title from Test Page',
        Body: 'Test Body',
        IsImportant: false,
      },
    },
  };

  const handleOpenModal = () =>
  {
    if (editCardRef.current)
    {
      editCardRef.current.openModal();
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">EditCard Component Test Page</h1>
      <p className="mb-6 text-gray-600">
        Click the button below to open the modernized EditCard modal. Check the browser console to
        see save payloads.
      </p>

      <button
        onClick={handleOpenModal}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
      >
        Open EditCard Modal
      </button>

      {lastSavedData && (
        <div className="mt-8 p-4 bg-gray-100 border rounded">
          <h2 className="text-lg font-semibold mb-2">Last Saved Data:</h2>
          <pre className="text-sm overflow-x-auto">{JSON.stringify(lastSavedData, null, 2)}</pre>
        </div>
      )}

      <EditCard ref={editCardRef} config={config} />
    </div>
  );
};

export default EditCardTestPage;
